import { render } from "./MedicalHistory.vue?vue&type=template&id=5091151a&scoped=true"
import script from "./MedicalHistory.vue?vue&type=script&lang=js"
export * from "./MedicalHistory.vue?vue&type=script&lang=js"

import "./MedicalHistory.vue?vue&type=style&index=0&id=5091151a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5091151a"]])

export default __exports__